import { Module } from 'wrapper6'
import Modalbox from '../utils/_modal-box'

export default class VideoModal extends Module {
  ready (app) {
    setTimeout(() => new Modalbox('.open-video-modal'), 50)
  }
}
